import React, { useState } from "react";
import SVG from "react-inlinesvg";
import { useSelector, shallowEqual, useDispatch } from "react-redux"
import SimpleTable from "my-simple-react-table";
import { toAbsoluteUrl } from "../../../../../../../../../../_metronic/_helpers";
import { formatDate, formatMonthYear, formatLongDate } from "../../../../../../../../../util/Helpers";
import * as handlers from "../../../../../../../_redux/selected-user/selectedUserHandlers";

const Statements = props => {

    /* Get Account details from redux */
    const accountDetails = useSelector(({selectedUser}) => {
        return selectedUser.data?.accounts.filter(acc => acc.accountId === props.match.params.accountId)[0]?.details;
	}, shallowEqual);

	const [tab, setTab] = useState("confirmation");
	const dispatch = useDispatch();
	
	const formatStatement = title => row => {
		return <div className="d-flex align-items-center" style={{whiteSpace: "nowrap"}}>
					<span className={`svg-icon svg-icon-lg svg-icon-primary mr-4`}>
						<SVG
							title=" "
							src={toAbsoluteUrl("/media/svg/files/pdf.svg")}
						/>
					</span>
					<div>
						<span className=" mb-1 font-size-lg">
							{formatMonthYear(row.date)}. {title}
						</span>
					</div>
				</div>
	}

	const tradeConfirmation = row => {
		return <div className="d-flex align-items-center" style={{whiteSpace: "nowrap"}}>
					<span className={`svg-icon svg-icon-lg svg-icon-primary mr-4`}>
						<SVG
							title=" "
							src={toAbsoluteUrl("/media/svg/files/pdf.svg")}
						/>
					</span>
					<div>
						<span className=" mb-1 font-size-lg pl-5">
							{formatLongDate(row.date)} 
						</span>
					</div>
				</div>
	}

	/* Download Button */
    const downloadButton = title => row => {
        return  <button
                    className="btn btn-icon btn-white btn-hover-primary btn-sm mx-0 mx-10"
					onClick={downloadFile({...row, name: `${title} ${row.date}`})}
                >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                        <SVG
                        title="Dowload File"
                        src={toAbsoluteUrl("/media/svg/icons/Files/Download.svg")}
                        />
                    </span>
                </button>
	}

	/* Download A file */
	const downloadFile = data => _ => {
		dispatch(handlers.downloadStatement(accountDetails.userId, accountDetails.accountId, data?.key, data.name));
	}

    return <div className="card card-custom gutter-b">
                <div className="card-header pt-5 pb-4">
                    <div className="card-toolbar w-100">
                        <ul className="nav nav-pills nav-pills-sm nav-dark-75 w-100" style={{"justifyContent": "space-between"}}>
                            
							<li className="nav-item">
                                <button
									className={`btn btn-lg nav-link py-2 px-4 ${tab === "confirmation" ? "active" : ""}`} 
									onClick = {_ => setTab("confirmation")}
								>
									Trade Confirmation
								</button>
                            </li>
							<li className="nav-item">
								<button 
									className={`btn btn-lg nav-link py-2 px-4 ${tab === "account" ? "active" : ""}`} 
									onClick = {_ => setTab("account")}
								>
									Account Statement
								</button>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* <!--begin::Body--> */}
				<div className="card-body pt-2 pb-5 mt-n3">
					<div className="tab-content mt-5" id="myTabTables11">
						{/* <!--begin::Tap pane--> */}
						<div 
							className={`tab-pane fade ${tab === "confirmation" ? "show active" : ""}`} 
							role="tabpanel" 
						>
							<SimpleTable
								data={accountDetails?.statement?.confirmation}
								columns={[
											{title:"", format: tradeConfirmation},
											{title:"", format: _ => <span className="pr-10">Trade Confirmation</span>},
											{title:"", format: downloadButton("Trade Confirmation")}
										]} 	
							/>
							
						</div>
						{/* <!--end::Tap pane--> */}
						{/* <!--begin::Tap pane--> */}
						<div 
							className={`tab-pane fade ${tab === "account" ? "show active" : ""}`} 
							role="tabpanel" 
						>
							<SimpleTable
								data={accountDetails?.statement?.account}
								columns={[
											{title:"", format: formatStatement("Account Statement")},
											{title:"", format: row => formatDate(row.date)},
											{title:"", format: downloadButton("Account Statement")}
										]} 	
							/>
						</div>
						{/* <!--end::Tap pane--> */}
					</div>
				</div>
				{/* <!--end::Body--> */}

            </div>
}

export default Statements;